import React from "react";
import { MapPin, Mail, Clock, Facebook, Youtube, Instagram, Linkedin, DollarSign } from "lucide-react";
import { Link } from "react-router-dom";
import SectionHeading from "../components/SectionHeading";
import ContactForm from "../components/ContactForm";
import { contactPage, contact } from "../data/siteData";

const Contact = () => {
  return (
    <div>
      <section className="bg-p3-cream py-16">
        <div className="max-w-4xl mx-auto px-5 text-center">
          <h1 className="font-heading font-extrabold text-4xl text-p3-navy mb-3">{contactPage.headline}</h1>
          <div className="flex items-center justify-center gap-5 mt-5">
            <span aria-disabled="true" title="Coming soon" className="text-p3-muted/40 cursor-not-allowed"><Facebook size={20} /></span>
            <span aria-disabled="true" title="Coming soon" className="text-p3-muted/40 cursor-not-allowed"><Youtube size={20} /></span>
            <span aria-disabled="true" title="Coming soon" className="text-p3-muted/40 cursor-not-allowed"><Instagram size={20} /></span>
            <span aria-disabled="true" title="Coming soon" className="text-p3-muted/40 cursor-not-allowed"><Linkedin size={20} /></span>
            <Link
              to="/how-to-order"
              title="How to Order (Bitcoin Payment Instructions)"
              className="text-p3-gold hover:text-p3-navy transition-colors"
            >
              <DollarSign size={20} />
            </Link>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-5 lg:px-8">
          <SectionHeading eyebrow="Global reach" title="Where We Are" center />
          <div className="grid sm:grid-cols-3 gap-6">
            {contactPage.regions.map((r) => (
              <div key={r.title} className="rounded-2xl overflow-hidden shadow-md group">
                <div className="h-40 overflow-hidden">
                  <img src={r.image} alt={r.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-5 bg-white">
                  <h3 className="font-heading font-bold text-p3-navy mb-1">{r.title}</h3>
                  <p className="text-sm text-p3-muted">{r.detail}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-p3-cream">
        <div className="max-w-6xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-10">
          <div className="bg-white rounded-2xl shadow-lg p-8 space-y-5">
            <h3 className="font-heading font-bold text-xl text-p3-navy mb-2">Get in Touch</h3>
            <p className="flex items-start gap-3 text-sm text-p3-muted">
              <MapPin size={18} className="text-p3-gold shrink-0 mt-0.5" /> {contact.address}
            </p>
            <p className="flex items-center gap-3 text-sm text-p3-muted">
              <Mail size={18} className="text-p3-gold shrink-0" /> {contact.email}
            </p>
            <p className="flex items-start gap-3 text-sm text-p3-muted">
              <Clock size={18} className="text-p3-gold shrink-0 mt-0.5" /> Working Hours: {contact.hours}, Monday to Friday
            </p>
          </div>
          <ContactForm />
        </div>
      </section>
    </div>
  );
};

export default Contact;
